import { ThreeDotsLoaderAnimatedSvg } from "../Svgs";
import { IBankAccountResolverViewProps } from "./BankAccountResolver";

export const View = (props: IBankAccountResolverViewProps) => {
  const {
    isLoading,
    isError,
    isBankAccountResolved,
    accountName,
    errorMessage,
  } = props;

  return isLoading || isBankAccountResolved || isError ? (
    <div className="bank-account-resolver--container">
      {isLoading ? (
        <ThreeDotsLoaderAnimatedSvg fill={"#3b7cff"} height={5} width={30} />
      ) : !accountName ? null : (
        <span className="text-primary">{accountName}</span>
      )}
      {isError ? <div className="text-danger">{errorMessage}</div> : null}
    </div>
  ) : null;
};
